<div class="main">
    <div *ngIf="loginError" class="full" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center">
        <h1>Login failed</h1>
        <p>Please try again or contact Kemppi Support for help</p>
        <br>
        <br>
        <br>

        <code>
            <small *ngIf="loginError">{{ loginError }}</small>
        </code>
        <code>
            <small *ngIf="loginErrorDescription"><i>{{ loginErrorDescription }}</i></small>
        </code>
    </div>
</div>
<!-- ACTIONBAR BUTTONS -->
<ks-actionbar
        [hasCancel]="false"
        [hasSave]="false"
>
